import { render, staticRenderFns } from "./EMS.vue?vue&type=template&id=970c5150&scoped=true&"
import script from "./EMS.vue?vue&type=script&lang=js&"
export * from "./EMS.vue?vue&type=script&lang=js&"
import style0 from "./EMS.vue?vue&type=style&index=0&id=970c5150&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970c5150",
  null
  
)

export default component.exports